import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@sm/wds-react';
import { t, defineMessages } from '@sm/intl';
import { IconLogoGoldie } from '@sm/wds-icons';
import { useSurveyTheme, createSurveyStyles } from '@sm/webassets';
import checkDarkMode from '~app/helpers/luminance';
import './footer.scss';

const useStyles = createSurveyStyles(theme => {
  return {
    ctaLink: {
      color: theme?.secondaryAccentColor,
      backgroundColor: theme?.primaryAccentColor,
      fontFamily: theme?.questionBody?.fontFamily,
      transition: 'all 0.2s linear',
      '&:hover': {
        borderColor: theme?.primaryAccentColor,
        backgroundColor: theme?.primaryAccentColor,
        boxShadow: `0 0 4px #000060 ${theme?.primaryAccentColor}`,
        outlineOffset: '5px',
        outline: `1px solid ${theme?.primaryAccentColor}`,
      },
    },
  };
});

const DEFAULT_COPY = defineMessages({
  GET_STARTED: {
    id: 'Footer.GetStarted',
    defaultMessage: 'Get Started',
    description: '[Type: Button][Vis.: low] - Get Started Button',
  },
  ALL_SET: {
    id: 'Footer.AllSet',
    defaultMessage: 'All set! Now create your own interactive quiz.',
    description: '[Type: Text][Vis.: low] - All Set Info Message',
  },
});

const Footer = ({ isKiosk, isGrayScale }) => {
  const theme = useSurveyTheme();
  const { ctaLink } = useStyles();
  const backgroundColor = theme.primaryBackgroundColor || '#fff';
  const isDarkMode = checkDarkMode(backgroundColor);
  const ctaColor = isDarkMode ? 'black' : 'primary';
  let goldieLogoColor;

  if (isDarkMode) {
    goldieLogoColor = 'light';
  } else {
    goldieLogoColor = isGrayScale ? 'dark-muted' : 'primary'; // account for 'dark-muted' or 'light'
  }

  if (isKiosk) {
    return null;
  }

  return (
    <footer className="sm-footer--container">
      <div className="sm-footer--content">
        <div className="sm-footer--content-cell">
          <a className="sm-footer--logo" href="/?ut_source=quiz_results" target="_blank" rel="noreferrer">
            <IconLogoGoldie size="xl" color={goldieLogoColor} />
          </a>
        </div>
        <div className="sm-footer--content-cell sm-footer--text">
          <span className="sm-footer--content">{t(DEFAULT_COPY.ALL_SET)}</span>
        </div>
        <div className="sm-footer--content-cell">
          <Button
            data-testid="Footer__QuizCTA"
            size="md"
            className={ctaLink}
            color={ctaColor}
            target="_blank"
            href="/create/?create=scratch&quiz=true&ut_source=quiz_results"
            rel="noreferrer"
          >
            {t(DEFAULT_COPY.GET_STARTED)}
          </Button>
        </div>
      </div>
    </footer>
  );
};

Footer.propTypes = {
  isKiosk: PropTypes.bool,
  isGrayScale: PropTypes.bool,
};

Footer.defaultProps = {
  isKiosk: false,
  isGrayScale: false,
};

export default Footer;
